import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  ReportRecipient,
  ReportRecipientsResponse,
  ReportRecipientsFilteredResponse,
  CreateReportRecipientPayload,
  UpdateReportRecipientPayload,
} from '../../shared/models/report-recipient.models';

@Injectable({ providedIn: 'root' })
export class ReportRecipientService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getReportRecipients() {
    return this.http.get<ReportRecipientsResponse>(`${this.apiUrl}/api/report-recipients`);
  }

  getReportRecipientsByCategoryIds(situationCategoryIds: string[], situationTaxonomyId?: string) {
    let params = new HttpParams();
    situationCategoryIds.forEach((id) => (params = params.append('situationCategoryIds', id)));
    if (situationTaxonomyId) params = params.set('situationTaxonomyId', situationTaxonomyId);
    return this.http.get<ReportRecipientsFilteredResponse>(`${this.apiUrl}/api/report-recipients`, {
      params,
    });
  }

  getReportRecipientById(id: string) {
    return this.http.get<ReportRecipient>(`${this.apiUrl}/api/report-recipients/${id}`);
  }

  createReportRecipient(payload: CreateReportRecipientPayload) {
    return this.http.post<ReportRecipient>(`${this.apiUrl}/api/report-recipients`, payload);
  }

  updateReportRecipient(payload: UpdateReportRecipientPayload) {
    return this.http.put<ReportRecipient>(`${this.apiUrl}/api/report-recipients`, payload);
  }

  deleteReportRecipient(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/report-recipients/${id}`);
  }
}
